<template>
  <img
    v-if="props.src && !imageNotFound"
    loading="lazy"
    class="object-cover h-full w-full"
    :src="String(props.src)"
    :alt="props.alt || ''"
    @error="onError"
  />
  <img
    v-else
    class="object-cover h-full w-full"
    loading="lazy"
    :src="getNotFoundImage()"
    :alt="props.alt || ''"
  />
</template>

<script setup lang="ts">
import type {Maybe} from "@graphql-tools/utils"

const props = defineProps<{
  src?: Maybe<string>,
  alt?: Maybe<string>
}>()

const template = useUniWebTemplate()

import defaultNotFound from 'assets/images/default/not-found.png'
import poggersNotFound from 'assets/images/poggers/not-found.png'
import materidouskaNotFound from 'assets/images/materidouska/not-found.png'

import {useUniWebTemplate} from "~/composables/useUniWebTemplate";
import {TemplateList} from "~/libs/constants/TemplateList";

const imageNotFound = ref(false)

const getNotFoundImage = () => {
  switch (template.uniWebTemplateNameLowerCase) {
    case TemplateList.MATERIDOUSKA:
      return materidouskaNotFound
    case TemplateList.POGGERS:
      return poggersNotFound
    default:
      return defaultNotFound
  }
}

const onError = (e) => {
  imageNotFound.value = true
}
</script>
